import { AuthStateService } from './../../service/auth-state.service';
import { Component, OnInit } from '@angular/core';
import { ImportData } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-impersonation',
  templateUrl: './impersonation.component.html',
  styleUrls: ['./impersonation.component.scss']
})
export class ImpersonationComponent implements OnInit {
  public currentUser!: ImportData;

  constructor(
    private userService: UserService,
    private authStateService: AuthStateService
  ) {}

  ngOnInit(){
    this.userService.currentUser$.subscribe((result) => {
      if (result.Username) {
        this.currentUser = result;
      }
    })
  }

  stopImpersonating(){
    if(this.authStateService.activeAccount?.username){
      this.userService.toggleImpersonate(this.authStateService.activeAccount.username, false);
    }
  }

}
